import styled from 'styled-components'
import { pxToRem } from 'styles/functions'
import { videoRatioValue, type VideoRatio } from './videoRatio'

interface StyledVideoContainerProps {
  theme: any;
  $hasLegend: boolean;
  $ratio: VideoRatio;
}
export const StyledVideoContainer = styled.div<StyledVideoContainerProps>`
  background-color: transparent;
  position: relative;
  aspect-ratio: ${({ $ratio }) => 1 / videoRatioValue($ratio)};
  margin: ${(props) => (props.$hasLegend ? `${pxToRem(20)} ${pxToRem(20)} 0 ${pxToRem(20)}` : pxToRem(20))};

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`
